import { BaseDataService } from './BaseDataService';
import { Organization, PVAKeyValue } from '../../models';
import { NotificationService } from '../../services';

export class PVAKeyValueDataService extends BaseDataService<PVAKeyValue> {
    constructor(notificationService: NotificationService) {
        super('PVAKeyValue', 'PVAKeyValues', notificationService);
    }

    public getAllByOrganization(organization: Organization): Promise<any> {
        var endpoint = `${this.endpointRoot}/all/${organization.id}`;
        const init = this.buildRequestInit('GET');

        return fetch(endpoint, init).then((response) => {
            if (response.ok) {
                return response.json();
            }

            const message = `Error retrieving statements.`;
            this.notificationService.addError(message);
            throw new Error(message);
        });
    }
}


// WEBPACK FOOTER //
// ./src/services/api/PVAKeyValueData.tsx